import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderId',
})
export class OrderIdPipe implements PipeTransform {
  public transform(value: number): unknown {
    return 'S' + value.toString().padStart(9, '0');
  }
}
